export default __webpack_public_path__ + "static/product12-6d1f9cc77b93e7f23699ee367817c5c6.jpg";